import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTAButtons from "@components/new-ui/CTAButtons";
import CTASection from "@components/new-ui/CTASection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Image from "next/image";
import React, { useEffect, useMemo, useState } from "react";
import { LuArrowUpRight } from "react-icons/lu";
import { PiCaretCircleLeftThin, PiCaretCircleRightThin } from "react-icons/pi";

interface Feature {
    mediaUrl: string;
}

interface News {
    imageUrl: string;
    description: string;
    externalLink: string;
    releasedDate: string;
    seoValue?: string;
}

interface Media {
    src: string;
    width: number;
    height: number;
    alt: string;
}

interface NewsCollections {
    year: string;
    newsList: News[];
}

type TabItems = "news" | "press" | "media" | "update";
interface Tab {
    id: TabItems;
    label: string;
}

const newsData: NewsCollections[] = [
    {
        year: "2025",
        newsList: [
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/businessline.png",
                description: "Gallabox raises $3.5 million to strengthen capabilities and expand geographic footprint",
                externalLink:
                    "https://www.thehindubusinessline.com/companies/gallabox-raises-35-million-to-strengthen-capabilities-and-expand-geographic-footprint/article69154795.ece",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/yourstory.png",
                description: "Conversational commerce platform Gallabox raises $3.5M in seed round led by",
                externalLink: "https://yourstory.com/2025/01/conversational-commerce-platform-gallabox-seed-funding-fuse",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/pymnts.png",
                description: "Gallabox Raises $3.5 Million to Help Small Businesses Create AI Agents",
                externalLink: "https://www.pymnts.com/news/investment-tracker/2025/gallabox-raises-3-million-dollars-help-small-businesses-create-artificial-intelligence-agents/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/inc4.png",
                description: "Prime Ventures-Backed Gallabox Nets $3.5 Mn To Build Agentic AI Solutions",
                externalLink: "https://inc42.com/buzz/prime-ventures-backed-gallabox-nets-3-5-mn-to-build-agentic-ai-solutions/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/entrepreneur.png",
                description: "CHK, Shoppin, and Gallabox Secure Early-Stage Funding to Fuel Growth",
                externalLink: "https://www.entrepreneur.com/en-in/news-and-trends/chk-shoppin-and-gallabox-secure-early-stage-funding-to/486348",
                releasedDate: "January 30, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/technasia.png",
                description: "Oxyle Raises $16M to Fight Water Contaminants, with 99% Destruction",
                externalLink: "https://www.startuphub.ai/oxyle-raises-16m-to-fight-water-contaminants-with-99-destruction/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/campaign.png",
                description: "50,000 businesses, one goal: Gallabox looks at powering customer engagement at scale",
                externalLink: "https://www.campaignindia.in/article/50-000-businesses-one-goal-gallabox-looks-at-powering-customer-engagement-at-sc/500781",
                releasedDate: "January 30, 2025",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/startuphub.png",
                description: "Oxyle Raises $16M to Fight Water Contaminants, with 99% Destruction",
                externalLink: "https://www.startuphub.ai/oxyle-raises-16m-to-fight-water-contaminants-with-99-destruction/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/journal.png",
                description: "Gallabox Betting on Wider WhatsApp Adoption in U.S. - San Diego Business Journal",
                externalLink: "https://www.sdbj.com/technology/software/gallabox-betting-on-wider-whatsapp-adoption-in-u-s/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/viestories.png",
                description: "Conversational Commerce Platform Gallabox Raises $3.5Mn In Seed Round",
                externalLink: "https://viestories.com/funding-alert/conversational-commerce-platform-gallabox-raises-35mn-in-seed-round-8669820",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/sass-news.png",
                description: "Gallabox Raises $3.5 Million in Seed Round",
                externalLink: "https://viestories.com/funding-alert/conversational-commerce-platform-gallabox-raises-35mn-in-seed-round-8669820",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/startup-city.png",
                description: "Indian Enterprise Tech Startup 'Gallabox' bags $3. 5 million in Seed Funding",
                externalLink: "https://startup.siliconindia.com/startup-funding/indian-enterprise-tech-startup--gallabox--bags-3-5-million-in-seed-funding-nwid-48471.html",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },
        ],
    },
    {
        year: "2022",
        newsList: [
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/businessline.png",
                description: "Conversational commerce platform Gallabox raises $1.2 million",
                externalLink: "https://www.thehindubusinessline.com/companies/conversational-commerce-platform-gallabox-raises-12-million/article66148675.ece",
                releasedDate: "November 17, 2022",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/ani.png",
                description: "Conversational Commerce Platform Gallabox raises USD 1.2M",
                externalLink: "https://www.aninews.in/news/business/business/conversational-commerce-platform-gallabox-raises-usd-12m20221117161354/",
                releasedDate: "November 17, 2022",
                seoValue: "nofollow",
            },

            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/hindu.png",
                description: "Chennai-based commerce platform Gallabox raises over ₹9 crore in seed funding",
                externalLink: "https://www.thehindu.com/business/chennai-based-commerce-platform-gallabox-raises-nearly-10-crore-in-seed-funding/article66148132.ece/",
                releasedDate: "November 17, 2022",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/inc4.png",
                description: "Gallabox Secures Funding To Help SMBs Improve Sales Conversions On WhatsApp",
                externalLink: "https://inc42.com/buzz/gallabox-secures-funding-to-help-smbs-improve-sales-conversions-on-whatsapp/",
                releasedDate: "January 29, 2025",
                seoValue: "nofollow",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/startup-story.png",
                description: "Gallabox – A SaaS startup provides businesses with the right tools to make every customer conversation more meaningful",
                externalLink: "https://www.figma.com/exit?url=https%3A%2F%2Fstartupstorymedia.com%2Fstories-2022-10-gallabox-startup-story%2F",
                releasedDate: "15 Apr 2022",
                seoValue: "nofollow",
            },
        ],
    },
];

const pre_releaseData: NewsCollections[] = [
    {
        year: "2025",
        newsList: [
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/gallabox.png",
                description: "Gallabox raises $3.5M to fuel its mission to democratize AI-driven conversational commerce for SMBs",
                externalLink: "/news/gallabox-raises-3.5-million-to-fuel-its-mission",
                releasedDate: "January 29, 2025 ",
            },
        ],
    },
    {
        year: "2022",
        newsList: [
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/gallabox.png",
                description: "Gallabox, a conversational commerce platform, raises $1.2 million to help SMBs grow their sales on WhatsApp",
                externalLink: "/news/gallabox-raises-1.2-million-to-help-smbs",
                releasedDate: "January 30, 2025",
            },
        ],
    },
];
const updates: NewsCollections[] = [
    {
        year: "2025",
        newsList: [
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/gallabox.png",
                description: "WhatsApp coexistence update: Connecting the Business app and API",
                externalLink: "/whatsapp-coexistence-update",
                releasedDate: "",
            },
            {
                imageUrl: "https://assets.gallabox.com/gb-home/press/gallabox.png",
                description: "July 1, 2025: Every WhatsApp Business pricing change you need to know",
                externalLink: "/whatsapp-business-pricing-July-2025-update",
                releasedDate: "",
            },
        ],
    },
];

const mediaData: Media[] = [
    { src: "https://assets.gallabox.com/gb-home/press/gallabox.png", width: 377, height: 240, alt: "Gallabox Press" },
    { src: "https://assets.gallabox.com/gb-home/press/gallabox-icon-white.png", width: 204, height: 204, alt: "Gallabox Icons" },
    { src: "https://assets.gallabox.com/gb-home/press/gallabox-icon-blue.png", width: 204, height: 204, alt: "Gallabox Blue Icons" },
    { src: "https://assets.gallabox.com/gb-home/press/gallabox-blue.png", width: 377, height: 240, alt: "Gallabox Blue Press" },
];

const tabs: Tab[] = [
    { id: "news", label: "News" },
    { id: "press", label: "Press release" },
    { id: "media", label: "Media kit" },
    { id: "update", label: "Updates" },
];

const PressLanding: React.FC = () => {
    const [active, setActive] = useState<TabItems>("news");
    const [selectedYear, setSelectedYear] = useState<string>("2025");
    const [filteredNewsList, setFilteredNewsList] = useState<News[]>([]);

    const dataMap: Record<Exclude<TabItems, "media">, NewsCollections[]> = useMemo(
        () => ({
            news: newsData,
            press: pre_releaseData,
            update: updates,
        }),
        []
    );

    const renderingData = useMemo(() => {
        return active === "media" ? [] : dataMap[active];
    }, [active, dataMap]);

    useEffect(() => {
        const filteredData = renderingData.find((data) => data.year === selectedYear)?.newsList ?? [];
        setFilteredNewsList(filteredData);
    }, [renderingData, selectedYear]);

    const handleTabs = (id: TabItems): void => {
        setSelectedYear("2025");
        setActive(id);
    };

    const renderCollectedsNews = () => {
        return (
            <section className={`${container_classname} flex md:flex-row flex-col md:justify-between mb-20`}>
                <div className="w-56 md:block hidden">
                    {renderingData.map(({ year }) => (
                        <div
                            key={year}
                            onClick={() => setSelectedYear(year)}
                            className={`pt-4 pb-4 cursor-pointer flex justify-between items-center text-lg ${selectedYear === year ? "font-bold" : "bg-white"}`}
                            style={{ borderTop: "1px solid black" }}
                        >
                            {year}
                            <LuArrowUpRight className={`transition-transform transform ${selectedYear === year ? "rotate-45" : "rotate-0"}`} />
                        </div>
                    ))}
                </div>

                <div className="block md:hidden">
                    <select
                        className="w-32 p-2 border border-solid border-gray-300 bg-white mx-auto"
                        value={selectedYear}
                        onChange={(event) => setSelectedYear(event.target.value)}
                    >
                        {renderingData.map(({ year }) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="grid md:grid-cols-3 gap-7 mx-auto md:mt-0 mt-6">
                    {filteredNewsList.map(({ description, imageUrl, releasedDate, externalLink, seoValue }, idx) => (
                        <div key={idx} className="w-72 border border-gray-200 border-solid overflow-hidden hover:shadow-md press-wrapper">
                            <Image src={imageUrl} width={298} height={100} alt={description} className="w-full" />
                            <div className="p-6 flex flex-col gap-5">
                                <a className="font-semibold h-24" href={externalLink} rel={seoValue}>
                                    {description}
                                </a>
                                <p className="text-gray-600 text-xs">{releasedDate}</p>
                            </div>
                            <style>{`
        .press-wrapper {
            border-bottom: 3px solid #CBD5E0;
            transition: border-bottom 0.3s ease;
        }
        .press-wrapper:hover {
            border-bottom: 3px solid #3364FA;
        }
    `}</style>
                        </div>
                    ))}
                </div>
            </section>
        );
    };

    return (
        <NewLayout
            title=" Gallabox Press Room | Latest News and Updates"
            description="Stay updated with the latest news, announcements, and stories about how Gallabox is democratizing AI-powered messaging for SMBs."
            canonical="https://gallabox.com/news"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/press/gallabox-press-room.png" }}
        >
            <section className="md:pb-60 pb-16 pt-20 md:pt-40 px-4" style={{ background: "linear-gradient(156deg, #000 7.74%, #3364FA 78.98%)" }}>
                <div className={`${container_classname} text-white`}>
                    <p style={{ color: "#01E6FF" }} className="md:mb-2 mb-4 text-sm font-medium">
                        NEWS AND UPDATES
                    </p>
                    <h1 className="text-gray-50 lg:text-new-h1 text-5xl font-bold gap-2 md:mb-5 mb-2" style={{ fontFamily: "Degular variable" }}>
                        Press Room
                    </h1>
                    <p>Stay updated with the latest news, announcements, and stories about how Gallabox is democratizing AI-powered messaging for SMBs.</p>
                </div>

                <div className={`${container_classname} md:hidden border block  bg-white border-gray-200 rounded-md border-solid p-8  mt-10`}>
                    <div>
                        <p
                            className="w-fit px-4 py-2 rounded-full border border-blue-400 border-solid text-blue-600 font-medium text-sm mb-3"
                            style={{ backgroundColor: "#DFE7FF" }}
                        >
                            Funding news
                        </p>
                        <h5 className="lg:text-6xl text-4xl mb-5 text-black font-bold" style={{ fontFamily: "Degular variable" }}>
                            Why Gallabox thinks WhatsApp is the future of sales and marketing
                        </h5>
                        <p className="mb-10 text-black">Jan 29, 2025, 08:00am EST</p>
                        <CTAButtons />
                    </div>
                    <Image src={"https://assets.gallabox.com/gb-home/press/karthick-ceo.png"} width={581} height={200} alt="Gallabox CEO" className="mt-10 md:mt-0" />
                </div>
            </section>

            <section className={`${container_classname} md:block hidden relative`} style={{ height: "480px" }}>
                <div className={`${container_classname} flex border  bg-white border-gray-200 rounded-xl border-solid p-8 -top-32 absolute`}>
                    <div>
                        <p
                            className="w-fit px-3 py-1 rounded-full border border-blue-400 border-solid text-blue-600 font-medium text-sm mb-3"
                            style={{ backgroundColor: "#DFE7FF" }}
                        >
                            Funding news
                        </p>
                        <h5 className="lg:text-6xl text-4xl mb-6 text-black" style={{ fontFamily: "Degular Display" }}>
                            Forbes: Why Gallabox thinks WhatsApp is the future of sales and marketing
                        </h5>
                        <p className="mb-20 text-black">Jan 29, 2025, 08:00am EST</p>
                        <CTAButtons
                            primaryButtonText="Know more"
                            urlLink=" https://www.forbes.com/sites/davidprosser/2025/01/29/why-gallabox-thinks-whatsapp-is-the-future-of-sales-and-marketing"
                        />
                    </div>
                    <Image src={"https://assets.gallabox.com/gb-home/press/karthick-ceo.png"} width={581} height={200} alt="Gallabox CEO" />
                </div>
            </section>

            <section className="flex justify-center md:mb-12 mb-2">
                <div className="flex md:gap-12 p-2 bg-gray-100   w-fit rounded-md text-base md:font-semibold  font-medium mt-12 md:mt-0 border border-solid border-gray-300 mb-12">
                    {tabs.map(({ id, label }) => (
                        <div
                            key={id}
                            className={`cursor-pointer ${active === id ? "bg-white py-2 px-4 rounded-md text-black" : "text-gray-600 py-2 px-4"}`}
                            onClick={() => {
                                handleTabs(id);
                            }}
                        >
                            {label}
                        </div>
                    ))}
                </div>
            </section>

            {active === "news" && renderCollectedsNews()}

            {active === "press" && renderCollectedsNews()}

            {active === "media" && (
                <section className={`${container_classname} mb-20`}>
                    <div className="flex gap-7 md:flex-row flex-col">
                        {mediaData.map(({ src, width, height, alt }, index) => (
                            <Image key={index} src={src} width={width} height={height} alt={alt} className="mx-auto md:mx-0" />
                        ))}
                    </div>
                    <section className="mx-14">
                        <div className={`${container_classname} flex md:flex-row flex-col p-6 justify-between rounded-md mt-12 bg-blue-100`}>
                            <p className="md:w-1/2 w-full">Please ensure our logo appears uniformly across all materials using the provided brand resources.</p>
                            <div className="flex items-center gap-5 md:mt-0 mt-4">
                                <h5 className="text-xl">Get Gallabox logo kit</h5>
                                <a className="bg-blue-600 text-white px-4 py-2 rounded-md hover:no-underline" href="/gallbox-mediakit.zip" download="gallbox-mediakit.zip">
                                    Download
                                </a>
                            </div>
                        </div>
                    </section>
                </section>
            )}

            {active === "update" && renderCollectedsNews()}
            <FeaturesSection />
            <div>
                <div className="w-full mb-20 mt-20">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>
                <IntegrationSection />
                <AwardsSection />
                <CTASection title="Turn connections into conversions" description="Take Gallabox for a 7-day ride" />
            </div>
        </NewLayout>
    );
};

export default PressLanding;

const FeatureCard: React.FC<Feature> = (props) => {
    return (
        <div className={"keen-slider__slide  flex flex-col gap-0 rounded"}>
            <Image src={props.mediaUrl} width={500} height={500} alt="" className="rounded-md" />
        </div>
    );
};

const sampleData: Feature[] = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/vijay-viswanathan.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/entreprenuer.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/inc-media.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/kellan-carter.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/prime-vp.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/startup-tn.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/money-mint.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/param-sigh.png",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/press/feature-section/zain-mir.png",
    },
];

const FeaturesSection: React.FC<{ features?: Feature[] }> = ({ features = sampleData }) => {
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [loaded, setLoaded] = React.useState(false);
    const [sliderRef, instanceRef] = useKeenSlider({
        mode: "free",
        drag: true,
        vertical: false,
        slides: {
            perView: 2.5,
            spacing: 20,
        },
        breakpoints: {
            "(max-width: 640px)": {
                slides: { perView: 1.1, spacing: 20 },
            },
        },
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    const disableLeftArrow = React.useMemo(() => currentSlide === 0, [currentSlide]);
    const disableRightArrow = React.useMemo(() => {
        const slidesLength = features.length;
        return slidesLength !== undefined && currentSlide === slidesLength - 1;
    }, [currentSlide, features]);

    return (
        <section
            className="lg:py-20 py-16"
            style={{
                background: "linear-gradient(283deg, #396AFF 0%, #000 98.82%)",
            }}
        >
            <div className={`${container_classname} flex flex-col lg:gap-12 gap-8`}>
                <div className="flex justify-between">
                    <div className="flex flex-col gap-6">
                        <h2 className={"lg:text-5xl text-3xl font-semibold text-white lg:max-w-5xl"} style={{ fontFamily: "Degular Display" }}>
                            Social mentions <span className="text-blue-600">@Gallabox</span>
                        </h2>
                    </div>
                    {loaded && instanceRef.current && (
                        <div className="lg:flex hidden text-white">
                            <PiCaretCircleLeftThin
                                style={{ cursor: disableLeftArrow ? "not-allowed" : "pointer" }}
                                size={60}
                                onClick={(e: any) => {
                                    if (!disableLeftArrow) e.stopPropagation() || instanceRef.current?.prev();
                                }}
                            />
                            <PiCaretCircleRightThin
                                style={{ cursor: disableRightArrow ? "not-allowed" : "pointer" }}
                                size={60}
                                onClick={(e: any) => {
                                    if (!disableRightArrow) e.stopPropagation() || instanceRef.current?.next();
                                }}
                            />
                        </div>
                    )}
                </div>
                <div ref={sliderRef} className="keen-slider w-full md:h-80" style={{ overflow: "visible" }}>
                    {features.map((feature, index) => (
                        <FeatureCard key={index} {...feature} />
                    ))}
                </div>
                {loaded && instanceRef.current && (
                    <div className="lg:hidden mx-auto flex gap-1 text-white">
                        <PiCaretCircleLeftThin
                            style={{ cursor: disableLeftArrow ? "not-allowed" : "pointer" }}
                            size={60}
                            onClick={(e: any) => {
                                if (!disableLeftArrow) e.stopPropagation() || instanceRef.current?.prev();
                            }}
                        />
                        <PiCaretCircleRightThin
                            style={{ cursor: disableRightArrow ? "not-allowed" : "pointer" }}
                            size={60}
                            onClick={(e: any) => {
                                if (!disableRightArrow) e.stopPropagation() || instanceRef.current?.next();
                            }}
                        />
                    </div>
                )}
            </div>
        </section>
    );
};
